<template>
    <div id="app">
        <router-view v-if="isRouterAlive"></router-view>
    </div>
</template>
<script>
export default {
    name: 'App',
    data () {
        return {
            isRouterAlive: true,
            loading: false
        }
    },
    provide () {
        return {
            reload: this.reload
        }
    },
    created () {
        this.setUserInfo()
        
    },
    methods: {
        setUserInfo () {
            const userInfoStr = localStorage.getItem('userInfo')
            if (userInfoStr) {
                this.$store.commit('setUserInfo', JSON.parse(userInfoStr))
            }
        },
        reload () {
            this.isRouterAlive = true
            this.$nextTick(() => {
                this.isRouterAlive = false
            })
        }
    }
}
</script>>
<style>
    @import "./assets/css/main.css";
    @import "./assets/css/color-dark.css";     /*深色主题*/
    /*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
</style>